// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://siypiyiaqxqyzztwpcao.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNpeXBpeWlhcXhxeXp6dHdwY2FvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA4NjI0MjYsImV4cCI6MjA4NjQzODQyNn0.SY3vD38jOG6_sZKC4JzAAQ13aXju2I7Ldk-EyOZxvSY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'sb-siypiyiaqxqyzztwpcao-auth-token',
  }
});